function aggSitePropsToRgBrief(aggProps, obj) {
	return {
		dataset: aggProps.dataset,
		obj,
		face2FaceSeparation: aggProps.face2FaceSeparation,
		face2SideSeparation: aggProps.face2SideSeparation,
		optimisePlots: aggProps.optimisePlots,
		unboundedTailor: aggProps.unboundedTailor,
		zoneBriefs: aggZonePropsToRgZoneBrief(aggProps.zones)
	};
}
function aggZonePropsToRgZoneBrief(zones) {
	const zoneBriefs = {};
	for (const key in zones) {
		const props = zones[key];
		zoneBriefs[key] = {
			unitMix: props.unitMix,
			floors: props.floors,
			buildings: props.maxPlotCount,
			...props.podium && { podium: {
				replaceLevels: props.podium.count,
				levelHeight: props.podium.height
			} },
			useDefaultSkeletonPosition: true,
			technicalSpaces: props.techSpaces,
			siteBoundaryFactor: props.siteBoundaryFactor,
			avoidNorthFactor: props.avoidNorthFactor,
			adjacencyFactor: props.adjacencyFactor,
			maxWingLength: props.maxWingLength
		};
	}
	return zoneBriefs;
}
export { aggSitePropsToRgBrief };

//# sourceMappingURL=index189.js.map